;
/*****************************************************************
 * Japanese language file for jquery.validationEngine.js (ver2.0)
 *
 * Transrator: tomotomo ( Tomoyuki SUGITA )
 * http://tomotomoSnippet.blogspot.com/
 * Licenced under the MIT Licence
 *******************************************************************/
(function ($) {
    $.fn.validationEngineLanguage = function () {};
    $.validationEngineLanguage = {
        newLang: function () {
            $.validationEngineLanguage.allRules = {
                "required": { // Add your regex rules here, you can take telephone as an example
                    "regex": "none",
                    "alertText": "* 必須項目です",
                    "alertTextCheckboxMultiple": "* 選択してください",
                    "alertTextCheckboxe": "* チェックボックスをチェックしてください"
                },
                "requiredInFunction": {
                    "func": function (field, rules, i, options) {
                        return (field.val() == "test") ? true : false;
                    },
                    "alertText": "* Field must equal test"
                },
                "minSize": {
                    "regex": "none",
                    "alertText": "* ",
                    "alertText2": "文字以上にしてください"
                },
                "groupRequired": {
                    "regex": "none",
                    "alertText": "* You must fill one of the following fields"
                },
                "maxSize": {
                    "regex": "none",
                    "alertText": "* ",
                    "alertText2": "文字以下にしてください"
                },
                "min": {
                    "regex": "none",
                    "alertText": "* ",
                    "alertText2": " 以上の数値にしてください"
                },
                "max": {
                    "regex": "none",
                    "alertText": "* ",
                    "alertText2": " 以下の数値にしてください"
                },
                "past": {
                    "regex": "none",
                    "alertText": "* ",
                    "alertText2": " より過去の日付にしてください"
                },
                "future": {
                    "regex": "none",
                    "alertText": "* ",
                    "alertText2": " より最近の日付にしてください"
                },
                //                "maxCheckbox": {
                //                    "regex": "none",
                //                    "alertText": "* チェックしすぎです"  "alertText": "選択できる数は3つまでです"
                //                },
                "maxCheckbox": {
                    "regex": "none",
                    "alertText": "* 選択できる数は ",
                    "alertText2": " つまでです"

                },
                "minCheckbox": {
                    "regex": "none",
                    "alertText": "* ",
                    "alertText2": "つ以上チェックしてください"
                },
                "equals": {
                    "regex": "none",
                    "alertText": "* 入力された値が一致しません"
                },
                "creditCard": {
                    "regex": "none",
                    "alertText": "* 無効なクレジットカード番号"
                },
                "jpcreditCard": {
                    "regex": /^([0-9]{16})$/,
                    "alertText": "* 無効なクレジットカード番号"
                },
                "customizeParm": {
                    //202406 
                    //"regex": /^((?!>|").)+$/, 
                    //"regex": />"/g,
                    // "regex": (?m)[^">]*$/,
                    //#"regex": /^[^">]*$/,
                    // "regex": /^[^"\';->&<\\:\/()[]{}|||\^!%\+]*$/,
                    "regex": /^[^">\';<&\\:\/\[\]()={}|||\^!%\+-]*$/,
                    "alertText": '* 記号を含めることはできません'
                },
                "customizeUrl": {
                    //202406
                    "regex": /^(?:(?!(?:f|ht)tps?:\/\/|www\.)[\s\S])*$/,
                    "alertText": '* URLを含めることはできません'
                },
                "jphone": {
                    // credit: jquery.h5validate.js / orefalo
                    "regex": /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7}|0[1-9]-[1-9][0-9]{3}-[0-9]{4}|0[5-9]0-[0-9]{4}-[0-9]{4})$/,
                    "alertText": "* 電話番号が正しくありません"
                },
                "jphoneAll": {
                    // credit: jquery.h5validate.js / orefalo
                    //"regex": /^0((\d{1}[-(]?\d{4}|\d{2}[-(]?\d{3}|\d{3}[-(]?\d{2}|\d{4}[-(]?\d{1}|[5789]0[-(]?\d{4}|800[-(]?\d{3})[-)]?\d{4}|(12|99|18|57)0[-(]?\d{3}[-)]?\d{3})$/,
                    //"regex": /^0(\d{1}[-]?\d{4}|\d{2}[-]?\d{3}|\d{3}[-]?\d{2}|\d{4}[-]?\d{1}|[5789]0[-]?\d{4}|800[-]?\d{3}[-]?\d{4}|(12|99|18|57)0[-]?\d{3}[-]?\d{3})$/,	
                    "regex": /^0((\d{1}[-]?\d{4}|\d{2}[-]?\d{3}|\d{3}[-]?\d{2}|\d{4}[-]?\d{1}|[5789]0[-]?\d{4}|800[-]?\d{3})[-]?\d{4}|(12|99|18|57)0[-]?\d{3}[-]?\d{3})$/,
                    "alertText": "* 電話番号が正しくありません"
                },
                "jpkana": { //全角と半角カタカナのみ場合
                    // credit: jquery.h5validate.js / orefalo
                    "regex": /^[\p{scx=Katakana}|ｦ-ﾟ]+$/u,
                    "alertText": "* カタカナで入力してください"
                },
                "jphan": { //漢字のみ場合
                    // credit: jquery.h5validate.js / orefalo
                    "regex": /^[\p{scx=Han}]+$/u,
                    "alertText": "* 漢字が正しくありません"
                },

                "jpfax": {
                    // credit: jquery.h5validate.js / orefalo
                    "regex": /^(0[1-9][1-9][0-9]{7})$/,
                    "alertText": "* FAX番号が正しくありません"
                },
                "jpass": {
                    // credit: jquery.h5validate.js / orefalo
                    //"regex": /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[@#$%^&*?_-]){6,16}$/, ///^(?![0-9a-zA-Z]+$)[a-zA-Z0-9~!@#$%^&*?_-]{10,16}$/,
                    // "regex": /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@;:])|(?=.*[A-Z])(?=.*[0-9])(?=.*[!@;:])|(?=.*[a-z])(?=.*[0-9])(?=.*[!@;:]))([a-zA-Z0-9!@;:]){8,}$/,
                    "regex": /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!;:@#$%?^&*_-]))([a-zA-Z0-9!;:@#$%?^&*_-]){10,16}$/,
                    "alertText": "英字（大文字及び小文字）、数字、記号を含む10文字以上で設定ください,使用可能な記号　!;:@#$%?^&*_-"
                },
                "email": {
                    // Shamelessly lifted from Scott Gonzalez via the Bassistance Validation plugin http://projects.scottsplayground.com/email_address_validation/
                    "regex": /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
                    "alertText": "* メールアドレスが正しくありません"
                },
                "integer": {
                    "regex": /^[\-\+]?\d+$/,
                    "alertText": "* 整数を半角で入力してください"
                },
                "quantity": {
                    "regex": /^([1-9]{1}[0-9]*)$/,
                    "alertText": "* 整数を半角で入力してください"
                },
                "number": {
                    // Number, including positive, negative, and floating decimal. credit: orefalo
                    "regex": /^[\-\+]?((([0-9]{1,3})([,][0-9]{3})*)|([0-9]+))?([\.]([0-9]+))?$/,
                    "alertText": "* 数値を半角で入力してください"
                },
                "date": {
                    "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/,
                    "alertText": "* 日付は半角で YYYY-MM-DD の形式で入力してください"
                },
                "ipv4": {
                    "regex": /^((([01]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))[.]){3}(([0-1]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))$/,
                    "alertText": "* IPアドレスが正しくありません"
                },
                "url": {
                    "regex": /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
                    "alertText": "* URLが正しくありません"
                },
                "zip": {
                    "regex": /^([0-9]{7}|[0-9]{3}-[0-9]{4})$/,
                    "alertText": "* 郵便番号がただしくありません"
                },
                "onlyNumberSp": {
                    "regex": /^[0-9\ ]+$/,
                    "alertText": "* 半角数字で入力してください"
                },
                "onlyLetterSp": {
                    "regex": /^[a-zA-Z\ \']+$/,
                    "alertText": "* 半角アルファベットで入力してください"
                },
                "onlyUserName": {
                    "regex": /^[@0-9a-zA-Z_\-\.]+$/,
                    "alertText": "* 半角英数-_@.で入力してください"
                },
                "onlyLetterNumber": {
                    "regex": /^[0-9a-zA-Z_\-]+$/,
                    "alertText": "* 半角英数-_で入力してください"
                },
                // --- CUSTOM RULES -- Those are specific to the demos, they can be removed or changed to your likings
                "ajaxUserCall": {
                    "url": "ajaxValidateFieldUser",
                    // you may want to pass extra data on the ajax call
                    "extraData": "name=eric",
                    "alertText": "* This user is already taken",
                    "alertTextLoad": "* Validating, please wait"
                },
                "ajaxNameCall": {
                    // remote json service location
                    "url": "ajaxValidateFieldName",
                    // error
                    "alertText": "* This name is already taken",
                    // if you provide an "alertTextOk", it will show as a green prompt when the field validates
                    "alertTextOk": "* This name is available",
                    // speaks by itself
                    "alertTextLoad": "* Validating, please wait"
                },
                "validate2fields": {
                    "alertText": "* 『HELLO』と入力してください"
                },

                "ajaxUserCallPhp": {
                    "url": site_url + "/verification/check",
                    "extraData": "salt=" + "&code=" + $('#syxs_csrf_token').val(),
                    "alertTextOk": "* このユーザー名は使用できます",
                    "alertText": "* このユーザはすでに登録されております",
                    "alertTextLoad": "* 検証中、しばらくお待ちください"
                },
                "ajaxUserCodeCall": {
                    "url": site_url + "/verification/ckun",
                    "extraData": "code=" + $('#syxs_csrf_token').val(),
                    // "alertTextOk": "* このユーザー名は使用できます",//このメールアドレスはすでに使われております。
                    "alertText": "* このユーザはすでに登録されております"
                    // "alertTextLoad": "* 検証中、しばらくお待ちください"
                },
                //****************************try validate img
                "validateMIME": {
                    "func": function (field, rules, i, options) {
                        //add to input tag: data-validation-engine="validate[required, custom[validateMIME[image/jpeg|image/png]]]"

                        var fileInput = field[0].files[0];
                        var MimeFilter = new RegExp(rules[3], 'i');

                        if (fileInput) {
                            return MimeFilter.test(fileInput.type);
                        } else {
                            return true;
                        }
                    },
                    "alertText": "* Wrong Mime Type."

                },
                //************************
                "checkFileType": {
                    "regex": "none",
                    "alertText": "* 画像形式が違います。"
                },

            };

        }
    };
    $.validationEngineLanguage.newLang();
})(jQuery);
